import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminPanelComponent } from 'src/components/admin-panel/admin-panel.component';
import { AuthResponseComponent } from 'src/components/auth-response/auth-response.component';
import { ComparePlanogramComponent } from 'src/components/compare-planogram/compare-planogram.component';
import { LoginComponent } from 'src/components/login/login.component';
import { PlanogramListComponent } from 'src/components/planogram-list/planogram-list.component';
import { SetupPlanogramComponent } from 'src/components/setup-planogram/setup-planogram.component';
import { CONFIG } from 'src/helper/app-config';
import { MsalGuard } from '@azure/msal-angular';
import { LandingPageComponent } from 'src/components/landing-page/landing-page.component';
import { AuthGuard } from './auth.guard';
import { SideAccordianComponent } from 'src/components/side-accordian/side-accordian.component';
import { GuidelinesInputComponent } from 'src/components/guidelines-input/guidelines-input.component';
import { AdminUpdateGuidelinesComponent } from 'src/components/admin-update-guidelines/admin-update-guidelines.component';
import { AdminDataUpdateComponent } from 'src/components/admin-data-update/admin-data-update.component';
import { AdminUserAnalyticsComponent } from 'src/components/admin-user-analytics/admin-user-analytics.component';
import { AdminGuidelinesInputComponent } from 'src/components/admin-guidelines-input/admin-guidelines-input.component';
import { AdminSetupComponentComponent } from 'src/components/admin-setup-component/admin-setup-component.component';
import { AdminCustomPlanogramComponent } from 'src/components/admin-custom-planogram/admin-custom-planogram.component';
import { CustomPlanogramLibraryComponent } from 'src/components/custom-planogram-library/custom-planogram-library.component';
import { DocumentationComponent } from 'src/components/documentation/documentation.component';

const routes: Routes = [
  {
    path: CONFIG.PATH.LANDING_PAGE,
    component: LandingPageComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.PLANOGRAMS,
    component: PlanogramListComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.PLANOGRAM + ':planogram_id',
    component: SetupPlanogramComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.NEWPLANOGRAM,
    component: SetupPlanogramComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.COMPAREPLANOGRAM,
    component: ComparePlanogramComponent,
    canActivate: [MsalGuard],
  },
  { path: CONFIG.PATH.LOGIN, component: LoginComponent },
  { path: CONFIG.PATH.AUTHRESPONSE, component: AuthResponseComponent },
  {
    path: CONFIG.PATH.ADMINPANEL,
    component: AdminPanelComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.LANDING_PAGE,
    component: LandingPageComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.GUIDELINES_INPUT + ':planogram_id',
    component: GuidelinesInputComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_UPDATE_GUIDELINES,
    component: AdminUpdateGuidelinesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_DATA_UPDATE,
    component: AdminDataUpdateComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_USER_ANALYTICS,
    component: AdminUserAnalyticsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_GUIDELINES_INPUT,
    component: AdminGuidelinesInputComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_SETUP_SCREEN + ':planogram_id',
    component: AdminSetupComponentComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_SETUP_SCREEN_NEW,
    component: AdminSetupComponentComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_CUSTOM_PLANOGRAM_NEW,
    component: AdminCustomPlanogramComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.ADMIN_CUSTOM_PLANOGRAM + ':planogram_id',
    component: AdminCustomPlanogramComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.CUSTOM_PLANOGRAM_LIBRARY,
    component: CustomPlanogramLibraryComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CONFIG.PATH.EMPTY,
    redirectTo: CONFIG.PATH.LANDING_PAGE,
    pathMatch: 'full',
  },
  {
    path: CONFIG.PATH.DOCS,
    component: DocumentationComponent,
    canActivate: [MsalGuard],
  },
  { path: '**', redirectTo: CONFIG.PATH.LANDING_PAGE },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled', // Don't perform initial navigation in iframes
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
